import "./BillingFormModal.css";

const BillingFormModal = ({
  isOpen,
  title,
  description,
  children,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="billing-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="billing-modal billing-modal--form"
        role="dialog"
        aria-modal="true"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="billing-modal__header">
          <div>
            <h3 className="billing-modal__title">{title}</h3>
            {description ? (
              <p className="billing-modal__description">{description}</p>
            ) : null}
          </div>
          <button
            type="button"
            className="billing-modal__close"
            onClick={onClose}
            aria-label="Close dialog"
          >
            ×
          </button>
        </div>
        <div className="billing-modal__body">{children}</div>
      </div>
    </div>
  );
};

export default BillingFormModal;
